/*Import Estilo*/
import '../institucional.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

/*Import Componentes*/
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';

/*Import SEO*/
import { SEOHelmet } from '../../../hooks/useSEO';

export default function PoliticasTrocas() {
    const seoData = {
        title: 'Políticas de Trocas e Devoluções - Fracaro Store',
        description: 'Conheça as políticas de trocas e devoluções da Fracaro Store. Garantimos sua satisfação com regras claras e transparentes.',
        keywords: 'trocas, devoluções, política, fracaro store, reembolso',
        url: window.location.href,
    };

    return (
        <section className='container-principal-institucional'>
            <SEOHelmet {...seoData} />
            <Cabecalho />
            <CookieAceite />
            <main>
                <div className='hero-institucional'>
                    <div className='hero-overlay'>
                        <h1>Políticas de Trocas e Devoluções</h1>
                        <p>Sua satisfação é nossa prioridade</p>
                    </div>
                </div>

                <div className='conteudo-institucional'>
                    <h2>1. Direito de Arrependimento</h2>
                    <p>
                        De acordo com o <strong>Código de Defesa do Consumidor (Art. 49)</strong>, você tem até 
                        <strong> 7 dias corridos</strong> após o recebimento do produto para solicitar a devolução, 
                        sem necessidade de justificativa.
                    </p>

                    <div className='destaque-box'>
                        <p>O prazo de 7 dias é contado a partir da data de recebimento do produto, conforme registrado pela transportadora.</p>
                    </div>

                    <h2>2. Condições para Troca ou Devolução</h2>
                    <p>Para que a troca ou devolução seja aceita, o produto deve atender às seguintes condições:</p>
                    <ul>
                        <li>Estar na embalagem original, sem sinais de uso</li>
                        <li>Acompanhar todos os acessórios, manuais e brindes (se houver)</li>
                        <li>Nota fiscal ou comprovante de compra</li>
                        <li>Não apresentar sinais de mau uso, manchas ou danos causados pelo cliente</li>
                    </ul>

                    <h2>3. Produtos com Defeito</h2>
                    <p>
                        Caso o produto apresente defeito de fabricação, você tem até <strong>30 dias corridos</strong> para 
                        solicitar a troca ou reparo. Após análise, providenciaremos:
                    </p>
                    <ol>
                        <li>A troca por um produto idêntico</li>
                        <li>A devolução do valor pago</li>
                        <li>O abatimento proporcional do preço</li>
                    </ol>

                    <h2>4. Como Solicitar</h2>
                    <p>Para solicitar uma troca ou devolução, siga os passos:</p>
                    <ol>
                        <li>Entre em contato pelo nosso <strong>WhatsApp (11) 99763-6154</strong> ou pelo email</li>
                        <li>Informe o número do pedido e o motivo da solicitação</li>
                        <li>Envie fotos do produto (em caso de defeito)</li>
                        <li>Aguarde nossa análise em até <strong>2 dias úteis</strong></li>
                        <li>Após aprovação, envie o produto de volta (frete por nossa conta em caso de defeito)</li>
                    </ol>

                    <h2>5. Reembolso</h2>
                    <p>
                        O reembolso será processado em até <strong>10 dias úteis</strong> após o recebimento e análise 
                        do produto devolvido. O valor será estornado na mesma forma de pagamento utilizada na compra.
                    </p>

                    <h3>Formas de reembolso:</h3>
                    <ul>
                        <li><strong>Cartão de crédito:</strong> Estorno na fatura em até 2 ciclos de fechamento</li>
                        <li><strong>PIX:</strong> Devolução em até 5 dias úteis na mesma chave</li>
                        <li><strong>Boleto:</strong> Depósito em conta bancária informada pelo cliente</li>
                    </ul>

                    <h2>6. Produtos Não Elegíveis</h2>
                    <p>Não aceitamos trocas ou devoluções de:</p>
                    <ul>
                        <li>Produtos personalizados ou sob encomenda</li>
                        <li>Itens de higiene pessoal que tenham sido abertos</li>
                        <li>Produtos com danos causados por mau uso do cliente</li>
                    </ul>

                    <div className='info-contato'>
                        <h3>Precisa de ajuda?</h3>
                        <p>
                            WhatsApp: <a href="https://wa.me/5511997636154" target="_blank" rel="noopener noreferrer">(11) 99763-6154</a><br />
                            Email: <a href="mailto:fracarostore@gmail.com">fracarostore@gmail.com</a>
                        </p>
                    </div>

                    <p className='ultima-atualizacao'>Última atualização: Janeiro de 2026</p>
                </div>
            </main>
            <Rodape />
        </section>
    );
}
